<div
	class="w-100 d-flex flex-column justify-content-center align-items-center"
	[ngClass]="{ 'py-5': showSpacing }"
	aria-busy="true"
	aria-live="polite"
>
	<ng-lottie [options]="options" aria-hidden="true"></ng-lottie>
	<h1 class="display-5 mb-3 mt-4" id="loading-title">{{ pageHeading }}</h1>
	<p>{{ 'sbb_loadingCard_description' | translate }}</p>
</div>
